//chapter1
export default {
    id : 15,//chapter number
    title : '15. PFMEA 작성방법 (2) - PFMEA와 Control Plan',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c15.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'PFMEA와 Control Plan',
            ],
            body2 : [
                'PFMEA와 Control Plan에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '15.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : '관리계획서는 공정 FMEA 작성을 위한 입력물이다.',//html available
                    answer : "2",
                    explain : '공정 FMEA는 관리도 작성을 위한 입력물이다.'
                },
                {
                    type : 'ox',
                    question : '개발되는 품질문서는 특성을 토대로 정보를 연결한다.',//html available
                    answer : "1",
                    explain : '정보의 정합성은 특성을 바탕으로 연계하여 개발된다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. 작업 지침서 작성 절차</h3>
                        <li>공정흐름도(특성 매트릭스) → FMEA → 관리계획서 → 작업지침서</li>
                        <li>품질 문서정보의 정합성 확보</li>
                        <p class="mg10"></p>
                        <h3>2. 공정흐름과 특성의 연계</h3>
                        <p class="mg10"></p>
                        <h3>3. 관리계획서 작성과 구성내용</h3>
                        <li>관리계획은 고객 요구에 따른 양품의 제품을 공급하는데 도움을 주는 것</li>
                        <li>공정산출물이 수입, 공정, 출하 각 단계에서 관리 상태임을 보장하기 위해 필요한 단계별 ① 예방방법, ② 검출방법, ③ 조치방법을 제공함</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c15.mp4',
        },
    ]
}